import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { showError } from '../common/ToastNotification';
import Loader from '../common/Loader';

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { userInfo, isLoading } = useAuth();

    if (isLoading) {
        return <Loader />; // Or a more sophisticated loading component
    }

    // If userInfo is null (not logged in), redirect to the login page.
    if (!userInfo) {
        showError("You are not logged in, please login again");
        return <Navigate to="/new_login" replace />;
    }

    // If userInfo exists, render the child components.
    return <>{children}</>;
};

export default ProtectedRoute;